import {
  WalletProviderPriority,
  getDefaultClient,
  getWalletProviderRegistry,
  hasExtension,
  registerExtension,
} from '@dynamic-labs-sdk/client/core';

import { registerSolanaNetworkProviderBuilder } from '../../registerSolanaNetworkProviderBuilder';
import { createWalletProviderForWaasSolana } from '../utils/createWalletProviderForWaasSolana';

export const WAAS_SOLANA_EXTENSION_KEY = 'waasSolana';

/**
 * Adds the Dynamic WaaS (Wallet as a Service) Solana extension to the Dynamic client.
 *
 * This extension enables embedded wallet functionality for Solana blockchain,
 * allowing users to have wallets managed by Dynamic's infrastructure.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addWaasSolanaExtension = (client = getDefaultClient()): void => {
  if (hasExtension({ extensionKey: WAAS_SOLANA_EXTENSION_KEY }, client)) {
    return;
  }

  registerExtension({ extensionKey: WAAS_SOLANA_EXTENSION_KEY }, client);
  registerSolanaNetworkProviderBuilder(client);

  const walletProviderRegistry = getWalletProviderRegistry(client);

  const walletProvider = createWalletProviderForWaasSolana(client);

  walletProviderRegistry.register({
    priority: WalletProviderPriority.WALLET_SDK,
    walletProvider,
  });
};
